import { Provider } from 'models';
import React from 'react';
import { Colors, Text } from 'library';
import ProviderReviews from './ProviderReviews';

const ProviderCardHeader = ({ provider, mobile = false }: { provider: Provider; mobile?: boolean }) => {
    return (
        <div
            style={{
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap-reverse',
                justifyContent: mobile ? 'center' : 'space-between',
            }}
        >
            <Text variant="body2" color={Colors.darkNavy} textStyle={{ marginTop: 6 }}>
                {!!provider.age ? `${provider.age} years old` : ' '}
            </Text>
            <ProviderReviews totalReviews={provider.total_reviews} reviewScore={provider.avg_review} />
        </div>
    );
};

export default ProviderCardHeader;
